interface SolutionsPhrasesProps {
 width: string
 bottom: string
 right: string
 syllable1: string
 syllable2: string
 syllable3?: string
}

export function SolutionsPhrases({
 width,
 bottom,
 right,
 syllable1,
 syllable2,
 syllable3
}: SolutionsPhrasesProps) {
 return (
  <div
   className="absolute font-['rns-milesblack'] font-bold text-[35px] text-[var(--solucoes-text)] leading-[40px]"
   style={{
    width: `${width}px`,
    bottom: `${bottom}px`,
    right: `${right}px`
   }}
  >
   {syllable1 && (
    <div className="text-left animate__animated animate__fadeInLeft animate__delay-200ms">
     {syllable1}
    </div>
   )}
   {syllable2 && (
    <div className="text-right animate__animated animate__fadeInRight animate__delay-450ms">
     <span className="text-[var(--solucoes-span)]">_</span>
     {syllable2}
     {syllable3 && <span className="text-[var(--solucoes-span)]">_</span>}
    </div>
   )}
   {syllable3 && (
    <div className="text-left animate__animated animate__fadeInUp animate__delay-700ms">
     <span className="text-[var(--solucoes-span)]">_</span>
     {syllable3}
    </div>
   )}
  </div>
 )
}
